import { Injectable } from "@angular/core";
import { MultiSort } from "@dialogs/select-sort/select-sort.component";
import { SavedSortResourceToSavedSortViewMapper } from "@models/mappers/saved-sort-resource-to-saved-sort-view.mapper";
import { SavedSortResource } from "@models/resource/saved-sort.resource";
import { SavedSortView } from "@models/ui/saved-sort-view.model";
import { SdkBase } from "@utilities/sdk-base/sdk.base";
import { map, Observable } from "rxjs";

const mapper = new SavedSortResourceToSavedSortViewMapper()

@Injectable({
    providedIn: 'root'
})
export class SavedSortSdk extends SdkBase {
    public getSavedSort(sortId: string): Observable<SavedSortView> {
        return this.makeHttpRequest<SavedSortResource>('get', `api2/saved-sorts/${sortId}`).pipe(
            map((response) => mapper.map(response))
        );
    }

    public createSavedSort(sort: MultiSort): Observable<SavedSortView> {
        return this.makeHttpRequest<SavedSortResource>('post', `api2/saved-sorts`, {
            first: {
              fieldId: sort.first.fieldId,
              direction: sort.first.direction === 'ASC'? 0: 1,
            },
            second: {
              fieldId: sort.second.fieldId,
              direction:sort.second.direction === 'ASC'? 0: 1,
            },
            third: {
              fieldId: sort.third.fieldId,
              direction: sort.third.direction === 'ASC'? 0: 1,
            }
          }).pipe(
            map((response) => mapper.map(response))
        );
    }
}
